<template>
  <NavigationComponent>
    <Standardfolie title="Views und Components">
      <p>
        Views und Components sind die Bausteine, aus denen die Seite aufgebaut
        ist.
      </p>
      <p>
        Views <v-icon>mdi-arrow-right</v-icon> Seiten, die über URLs erreichbar
        sind.
      </p>
      <VCode content="src/views/ExampleView.Vue"></VCode>
      <p>
        Components <v-icon>mdi-arrow-right</v-icon>Unterbausteine, aus denen die
        Seiten aufgebaut sind.
      </p>
      <VCode content="src/components/ExampleComponent.Vue"></VCode>
      <p>Aufbau der Datei identisch zur App.vue</p>
      <p>Einbinden einer Component über ihren Namen:</p>
      <VCode content="<ExampleComponent></ExampleComponent>"></VCode>
    </Standardfolie>
  </NavigationComponent>
</template>

<script>
import NavigationComponent from "@/components/NavigationComponent";
import Standardfolie from "@/components/Standardfolie";
import VCode from "@/components/VCode";
export default {
  name: "ViewsComponents",
  components: { Standardfolie, NavigationComponent, VCode }
};
</script>

<style scoped></style>
